import { useMemo, useState } from "react";

// Course -> Subject -> Chapter -> Topic -> Sub-Topic cascading picker, shared
// by the Questions and Videos tabs (both their filter bars and add/edit
// dialogs) so picking a Course narrows Subjects, picking a Subject narrows
// Chapters, and so on down to Sub-Topic.
export default function useHierarchyCascade({ courses, subjects, chapters, topics, subTopics }) {
  const [courseId, setCourseIdRaw] = useState("");
  const [subjectId, setSubjectIdRaw] = useState("");
  const [chapterId, setChapterIdRaw] = useState("");
  const [topicId, setTopicIdRaw] = useState("");
  const [subTopicId, setSubTopicId] = useState("");

  const subjectOptions = useMemo(
    () => subjects.filter((s) => !courseId || s.courseIds?.includes(courseId)),
    [subjects, courseId],
  );
  const chapterOptions = useMemo(
    () => chapters.filter((c) => !subjectId || c.subjectIds?.includes(subjectId)),
    [chapters, subjectId],
  );
  const topicOptions = useMemo(
    () => topics.filter((t) => !chapterId || t.chapterIds?.includes(chapterId)),
    [topics, chapterId],
  );
  const subTopicOptions = useMemo(
    () => subTopics.filter((st) => !topicId || st.topicIds?.includes(topicId)),
    [subTopics, topicId],
  );

  const setCourseId = (value) => {
    setCourseIdRaw(value);
    if (!subjects.some((s) => s.id === subjectId && s.courseIds?.includes(value))) {
      setSubjectIdRaw("");
      setChapterIdRaw("");
      setTopicIdRaw("");
      setSubTopicId("");
    }
  };
  const setSubjectId = (value) => {
    setSubjectIdRaw(value);
    if (!chapters.some((c) => c.id === chapterId && c.subjectIds?.includes(value))) {
      setChapterIdRaw("");
      setTopicIdRaw("");
      setSubTopicId("");
    }
  };
  const setChapterId = (value) => {
    setChapterIdRaw(value);
    if (!topics.some((t) => t.id === topicId && t.chapterIds?.includes(value))) {
      setTopicIdRaw("");
      setSubTopicId("");
    }
  };
  const setTopicId = (value) => {
    setTopicIdRaw(value);
    if (!subTopics.some((st) => st.id === subTopicId && st.topicIds?.includes(value))) {
      setSubTopicId("");
    }
  };

  return {
    courseId, subjectId, chapterId, topicId, subTopicId,
    setCourseId, setSubjectId, setChapterId, setTopicId, setSubTopicId,
    subjectOptions, chapterOptions, topicOptions, subTopicOptions,
  };
}
